const AuthStateEnum = {
  NOT_AUTHENTICATED: 0,
  AUTHENTICATED: 1,
  ERROR: 2
};

export default AuthStateEnum;
